__turbopack_context__.v({
  "basicValuePropsList": "styles-module__aLiUDW__basicValuePropsList",
});
